import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import config from "@/config.js";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = config.base_url + "/api/v1";

    Vue.axios.interceptors.request.use(
      (conf) => {
        conf.headers["Accept"] = "application/json";
        const token = JwtService.getToken();
        if (token) {
          conf.headers["Authorization"] = `Bearer ${token}`;
        }
        return conf;
      },
      (error) => Promise.reject(error)
    );

    Vue.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          JwtService.destroyToken();
          window.localStorage.removeItem("currentUser");
          if (window.location.pathname !== "/login") {
            window.location.assign("/login");
          }
        }
        return Promise.reject(error);
      }
    );
  },

  get(resource, params = {}) {
    return Vue.axios.get(resource, { params }).then((r) => r.data);
  },

  post(resource, data) {
    return Vue.axios.post(resource, data).then((r) => r.data);
  },

  put(resource, data) {
    return Vue.axios.put(resource, data).then((r) => r.data);
  },

  patch(resource, data) {
    return Vue.axios.patch(resource, data).then((r) => r.data);
  },

  delete(resource) {
    return Vue.axios.delete(resource).then((r) => r.data);
  },
};

export default ApiService;
